import React, { useState, useEffect } from "react";
import Moment from "moment";
import { safeFetch } from "../../../utils/security";
import { toast } from 'react-toastify';
import useDecode from "../../../hooks/useDecode";
import "./Message.scss";

interface IMessage {
  userChatCommunication: any;
  userId: string;
}

const Message: React.FC<IMessage> = ({ userChatCommunication }) => {
  const tokenResponse = useDecode("token");
  const [userTokenId, setUserTokenId] = useState("");

  useEffect(() => {
    if (tokenResponse !== undefined) {
      setUserTokenId(tokenResponse.extension_id);
    }
    Moment().locale("es");
  }, [tokenResponse]);

  // Función que fuerza la descarga con el nombre original
  const handleDownload = async (file: any) => {
    try {
      const response = await safeFetch(file.sasUri);
      if (!response.ok) {
        throw new Error("Error al descargar el archivo");
      }
      const blob = await response.blob();

      // Crear un enlace temporal para descargar el archivo con el nombre correcto
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = file.originalName || "archivo_descargado";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("❌ Error al descargar el archivo:", error);
      toast.error("No se pudo descargar el archivo.");
    }
  };

  return (
    <ul className="container-message-list">
      <li
        className={`message_block ${
          userChatCommunication?.userId === userTokenId ? "user" : ""
        }`}
      >
        <h2 className="message-header">
          <span className="message-author">
            {userChatCommunication?.autorUsuario === false
              ? `${userChatCommunication?.nombreAutor}:`
              : "Usted :"}
          </span>
          <time className="message-date" dateTime="date">
            {Moment(userChatCommunication?.created).format("LT")}h -{" "}
            {Moment(userChatCommunication?.created).format("DD/MM/YYYY")}
          </time>
        </h2>

        {/*Asunto */}
        <div className="container-subject">
          <span className="label-message">Asunto:</span>
          <span className="subject-body">{userChatCommunication?.asunto}</span>
        </div>

        {/*  Mensaje */}
        <div className="container-message">
          <span className="label-message">Mensaje:</span>
          <textarea
            className="message-body"
            readOnly
            defaultValue={userChatCommunication?.mensaje}
          ></textarea>
        </div>

        {/* Archivos adjuntos */}
        <div className="container-files-message">
          <span className="label-message-files">Documentos enviados:</span>
          <div className="files_block">
            {userChatCommunication?.files?.length > 0 ? (
              userChatCommunication.files.map((item: any, index: number) => (
                <div className="file-link-container" key={index}>
                  <button
                    type="button"
                    onClick={() => handleDownload(item)}
                    className="file-link"
                  >
                    <span className="file-icon"></span>
                    <span className="file-text">{item.originalName}</span>
                  </button>
                </div>
              ))
            ) : (
              <div className="file-link-container">
                <span className="label-message-files">
                  Sin documentos adjuntos
                </span>
              </div>
            )}
          </div>
        </div>
      </li>
    </ul>
  );
};

export default Message;
